import LogoLife from './logo-life';
export default LogoLife;
